module.exports = require("@walletconnect/ethereum-provider");